export default __webpack_public_path__ + "static/media/empty_person_purple.aec52f57.svg";